import type { HttpErrorResponse } from "@angular/common/http";
import type { ErrorHandler } from "@angular/core";
import { Injector, inject, isDevMode } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { HotToastService } from "@ngxpert/hot-toast";
import * as Sentry from "@sentry/angular";

export class GlobalErrorHandler implements ErrorHandler {
    private readonly injector = inject(Injector);
    private readonly sentry = Sentry.createErrorHandler({ logErrors: true });

    public handleError(error: Error | HttpErrorResponse): void {
        const notificationService = this.injector.get(HotToastService);
        const translocoService = this.injector.get(TranslocoService);

        let message = error.message;
        if (!isDevMode()) {
            message = translocoService.translate("handler.prod_message");
        }

        notificationService.error(message);

        this.sentry.handleError(error);
    }
}
